import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';

export const EDT_LIST_KEY = 'edt';

function fetchEDTs(): Promise<EdtPreview[]> {
  const requestURL = '/emplois-du-temps';
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }) => data || []);
}

interface EdtPreview {
  id: string;
  name: string;
  schoolyearId: string;
  schoolId: string;
  schoolName: string;
  schoolyear: number;
  createdAt: string;
  classroomNames: string[];
  nbOfSeances: number;
}

export function useAllEDTs() {
  return useQuery({
    queryKey: [EDT_LIST_KEY],
    queryFn: () => fetchEDTs(),
    placeholderData: [],
    refetchOnWindowFocus: false,
  });
}
